var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Опубліковані звернення")]),_c('b-overlay',{attrs:{"show":_vm.isLoading}},[_vm._l((_vm.tickets),function(t){return _c('publishedItem',{key:t.id,attrs:{"item":t}})}),_c('b-alert',{attrs:{"show":!_vm.isLoading && _vm.dataLoaded && !_vm.tickets.length,"variant":"primary"}},[_vm._v(" Нічого не знайдено ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }